import { collapseUnion } from '@feedyou/utils'
import { NlpModel } from '@feedyou-ai/feedbot-schema'

export function isModelChoosen(formData: any) {
  return (model: NlpModel): boolean =>
    collapseUnion(formData?.testAgainstModels)?.chosenModels?.includes(model.id)
}
